export var EVariant = /*#__PURE__*/function (EVariant) {
  EVariant["A"] = "a";
  EVariant["B"] = "b";
  EVariant["C"] = "c";
  EVariant["D"] = "d";
  return EVariant;
}({});
export var ETheme = /*#__PURE__*/function (ETheme) {
  ETheme["Light"] = "light";
  ETheme["Dark"] = "dark";
  return ETheme;
}({});